import { render } from "./PackagesPage.vue?vue&type=template&id=28ab6c08"
import script from "./PackagesPage.vue?vue&type=script&lang=js"
export * from "./PackagesPage.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/lbhq_agencyportal_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__